import { SET_LEADS_LIST, SET_SELECTED_LEAD, SET_SELECTED_LIST_IDS, CLEAR_SELECTED_LIST_IDS } from "../actions/actionTypes";

interface LeadListI {
    leadList: Array<any>,
    selectedLead: object,
    selectedListIds: string[],
}
const initialState = {
    leadList: [],
    selectedLead: {},
    selectedListIds: []
}

const leadListReducer = (state: LeadListI = initialState, action: { type: string; payload: any; }): LeadListI => {
    switch(action?.type) {
        case SET_LEADS_LIST:
            return {
                ...state,
                leadList: action?.payload
            }
        case SET_SELECTED_LEAD:
            return {
                ...state,
                selectedLead: action?.payload
            }
        case SET_SELECTED_LIST_IDS:
            return {
                ...state,
                selectedListIds: action?.payload
            }
        case CLEAR_SELECTED_LIST_IDS:
            return {
                ...state,
                selectedListIds: []
            }
        default:
            return state;
    }
}

export default leadListReducer;
